export const checkIfStringIsValidNdc = (ndc: string) => {
  const parts = ndc.split('-');
  if (parts.length === 3 && parts[0].length + parts[1].length + parts[2].length === 11) return true;
  return false;
};
